(function ($) {
    $(function () {
        $('[data-clear-input]').on('click', function () {
            var targetSelector = $(this).attr('data-clear-input');
            var targetElement = $(targetSelector);
            if (targetElement.length) {
                $(targetElement).val('');
                (targetElement).focus();
            }
        });

        // custom select boxes
        $('select.selectric-enable').selectric(
            {
                responsive: true,
                arrowButtonMarkup: "<span class='button'></span>",
                disableOnMobile: true
            }
        );
    });
})($JQ);